<template>
    <Navbar></Navbar>
    <div class="product-page">
        <div class="product-kv">
            <div class="swiper-container kv-container" ref="swiperRefs">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <video class="pc-pad" data-src="/assets/product/electronics/electronics-kv.mp4" alt="" muted
                                loop autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                x5-video-player-fullscreen="true"></video>
                            <video class="mb-only" data-src="/assets/product/electronics/electronics-kv-m.mp4" alt=""
                                muted loop autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
                        </div>
                        <div class="text-box">
                            <div class="title">
                                Electronics System<br v-if="!isPc"> Empower Intelligent Mobility
                            </div>

                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>
        <div class="product-center ">
            <div class="product-center-l">
                <div class="product-center-title">
                    Electronics System
                </div>
            </div>
        </div>

        <div class="product-tab-list">
            <div class="product-tab-bg">
                <div class="product-tab-item" v-for="(item, index) in carTypeList" :key="index"
                    @click="clickdataType = item.id" :class="item.id == clickdataType ? 'active' : ''">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="product-data-list">
            <div class="product-data-item" v-for="(item, index) in carData" :key="index">
                <div class="product-data-l">
                    <div class="product-data-t" v-html="item.name">
                    </div>
                    <div class="product-data-d" v-html="item.sellingPoint">
                    </div>
                    <a :href="item.productUrl" class="product-data-b" target="_blank">
                        <div>
                            READ MORE
                        </div>
                        <div class="img-box">
                            <img class="right-n" src="/assets/common/right-h.png" alt="">
                            <img class="right-h" src="/assets/common/right-n.png" alt="">
                        </div>
                    </a>
                </div>
                <div class="img-box product-data-r">
                    <img :src="item.pcImgVideo" alt=""></img>
                </div>
            </div>
        </div>
        <div v-if="loading" class="loading-tip">loading...</div>
        <!-- <div v-if="noMoreData" class="no-more-tip">没有更多数据了</div> -->


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { listSecond, productList } from '@/utils/common.js'

const swiperRefs = ref(null);
const swiperInstances = ref([]);
const isPc = ref(window.innerWidth > 768)

const productPageNum = ref(1);
const clickdataType = ref('');
const carTypeList = ref([]);

const carData = ref([]);
const loading = ref(false);
const noMoreData = ref(false);

const handleScroll = () => {
    if (loading.value || noMoreData.value) return;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight || window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

    if (scrollTop + clientHeight >= scrollHeight - clientHeight * 0.5) {
        loadMoreData();
    }
};

const loadMoreData = async () => {
    loading.value = true;
    try {
        productPageNum.value += 1;
        const response = await productList({
            pageNum: productPageNum.value,
            pageSize: 10,
            categoryId: 6,
            categorySecondId: clickdataType.value,
            publishStatus: 3
        });

        if (response && response.rows && response.rows.length > 0) {

            response.rows.forEach(item => {
                item.sellingPoint = (item.sellingPoint || '').toString().replace(/\\n/g, '<br>');
                carData.value.push(item);
            });
            if (response.rows.length < 10) {
                noMoreData.value = true;
            }
        } else {
            noMoreData.value = true;
            productPageNum.value -= 1;
        }
    } catch (error) {
        console.log('加载更多数据失败：', error);
        // 加载失败，页码回退
        productPageNum.value -= 1;
    } finally {
        loading.value = false;
    }
};

const initAllSwipers = async () => {
    await nextTick();
    const el = swiperRefs.value;
    if (el) {
        const swiper = new Swiper(el, {
            speed: 1300,
            pagination: {
                el: el.querySelector(".swiper-pagination"),
                clickable: true,
            },
            direction: "horizontal",
            simulateTouch: true,
            breakpoints: {
                768: {},
                1024: {}
            },
            on: {
                init: function () { },
                slideChangeTransitionStart(swiper) {
                    let swiperIndex = swiper.realIndex;
                },
            },
        });
        swiperInstances.value.push(swiper);
    }
};
watch(() => clickdataType.value, (newValue, oldValue) => {
    productPageNum.value = 1;
    carData.value = [];
    loading.value = false;
    noMoreData.value = false;
    getSecondData(newValue);
});

const getListSecond = async () => {
    try {
        const response = await listSecond({
            pageNum: 1,
            pageSize: 10,
            categoryId: 6,
            publishStatus: 3
        });

        if (response && response.rows) {
            carTypeList.value.push(...response.rows);
        }
        clickdataType.value = carTypeList.value[0].id;
        getSecondData(carTypeList.value[0].id);
    } catch (error) {
        console.log(error);
    }
};

const getSecondData = async (id) => {
    loading.value = true;
    try {
        const response = await productList({
            pageNum: productPageNum.value,
            pageSize: 10,
            categoryId: 6,
            categorySecondId: id,
            publishStatus: 3
        });
        carData.value = [];

        if (response && response.rows) {
                // console.log(item)

            response.rows.forEach(item => {
                if (item.name === '2ⁿᵈ Gen TBOX' ){
                    item.name = "2<span>nd</span> &nbsp Gen TBOX"
                }
                item.sellingPoint = (item.sellingPoint || '').toString().replace(/\\n/g, '<br>');
                carData.value.push(item);
            });
            noMoreData.value = response.rows.length < 10;
        }
        window.addEventListener('scroll', handleScroll);
    } catch (error) {
        console.log(error);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    initAllSwipers();
    getListSecond();
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
    swiperInstances.value.forEach(swiper => swiper.destroy(true, true));
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Electronics System - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics.html'
};

import { createApp } from 'vue';
import App from './electronics.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./electronics.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss">
.product-kv {
    min-height: 100vh;
}

.kv-container {
    width: 100%;
    height: auto;

    .text-box {
        position: absolute;
        top: 2.34rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        text-wrap: nowrap;

        .title {
            font-size: 0.5rem;
            font-weight: 800;
            white-space: nowrap;
        }

        .text {
            font-size: 0.2rem;
            font-weight: 300;
        }

        .product-kv-btn {
            background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
            border: 1px solid #676767;
            width: 1.71rem;
            height: 0.45rem;
            border-radius: 0.26rem;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
                color: #fff;
                font-size: 0.13rem;
                font-weight: 400;
                width: 70%;
                text-align: center;
            }

            img {
                width: 0.25rem;
                height: 0.25rem;
                object-fit: cover;
            }
        }
    }
}

.product-center {
    width: calc(100% - 3.12rem);
    padding: 1.27rem 1.56rem 0;

    .product-center-l {
        margin-bottom: 0.75rem;

        .product-center-title {
            font-size: 0.4rem;
            font-weight: 500;
            margin-bottom: 0.22rem;
            text-align: center;
        }

        .product-center-desc {
            font-size: 0.18rem;
            font-weight: 300;
            line-height: 0.3rem;
        }
    }

}

.product-tab-list {
    margin-top: 0.75rem;
    margin-left: 1.56rem;
    margin-right: 1.56rem;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba($color: #676767, $alpha: 0.36);

    .product-tab-bg {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .product-tab-item {
        font-size: 0.15rem;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
        position: relative;
        display: flex;
        padding: 0.14rem 0.25rem;
        background: #fff;

        &.active {
            color: #000;
            border: 1px solid rgba($color: #676767, $alpha: 0.36);
            border-bottom: unset;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: -1px;
                width: 100%;
                height: 2px;
                background: #fff;
            }
        }
    }
}

.product-data-list {
    width: calc(100% - 3.12rem);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 0.2rem;
    padding: 0.75rem 1.56rem;
    min-height: 50vh;

    .product-data-item {
        width: calc(45% - 0.2rem);
        height: 3.2rem;
        background: #F6F8FA;
        border-radius: 0.25rem;
        padding: 0.49rem 0.45rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .product-data-l {
            width: 50%;
            position: relative;

            .product-data-t {
                font-size: 0.25rem;
                font-weight: 600;
                margin-bottom: 0.25rem;
                display: flex;
                align-items: flex-start;

                span{
                    font-size: 0.15rem;
                    font-weight: 400;
                }
            }

            .product-data-d {
                font-size: 0.16rem;
                font-weight: 400;
                margin-bottom: 0.68rem;
                color: #999999;
                line-height: 0.25rem;
            }

            .product-data-b {
                width: 1.04rem;
                height: 0.35rem;
                border: 1px solid #676767;
                border-radius: 0.26rem;
                color: #676767;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.08rem;
                position: absolute;
                left: 0;
                bottom: 0;

                div {
                    font-size: 0.13rem;
                    font-weight: 400;
                }

                .img-box {
                    width: 0.05rem;
                    position: relative;
                    height: 0.1rem;

                    img {
                        position: absolute;
                        left: 0;
                        top: 0;
                        transition: all 0.3s;
                    }

                    .right-h {
                        opacity: 0;
                    }
                }


                &:hover {
                    background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                    box-shadow: 0px 2px 15px 1px rgba(232, 31, 30, 0.56);
                    border: unset;
                    color: #fff;

                    .img-box {

                        .right-h {
                            opacity: 1;
                        }

                        .right-n {
                            opacity: 0;
                        }
                    }
                }
            }
        }

        .product-data-r {
            width: 2.7rem;
        }
    }

}

.loading-tip {
    text-align: center;
    padding: 20px 0;
    font-size: 0.16rem;
    color: #666;
}

.no-more-tip {
    text-align: center;
    padding: 20px 0;
    font-size: 0.16rem;
    color: #999;
}

@media (max-width: 768px) {

    .product-kv {
        min-height: auto;
    }

    .kv-container {
        .text-box {
            top: 2.69rem;
            width: auto;
            // text-wrap: nowrap;
            text-align: center;
        }
    }

    .product-center {
        padding: 1.1rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .product-center-l {
            .product-center-title {
                font-size: 0.42rem;
                text-align: left;
            }
        }
    }

    .product-tab-list {
        margin-left: 0.45rem;
        margin-right: 0.45rem;
        width: calc(100% - 0.9rem);
        overflow-x: auto;
        overflow-y: hidden;
        justify-content: flex-start;

        .product-tab-item {
            font-size: 0.24rem;
            text-wrap: nowrap;
        }
    }

    .product-data-list {
        width: calc(100% - 0.9rem);
        padding: 0.75rem 0.45rem;

        .product-data-item {
            width: calc(50% - 0.6rem);
            flex-direction: column-reverse;
            justify-content: flex-end;
            padding: 0.3rem 0.2rem;
            height: auto;

            .product-data-l {
                width: 100%;

                .product-data-t {
                    font-size: 0.22rem;
                    height: 0.8rem;
                }

                .product-data-d {
                    font-size: 0.19rem;
                    margin-bottom: 0.1rem;
                    height: 4rem;

                }

                .product-data-b {
                    width: 1.64rem;
                    height: 0.5rem;
                    border-radius: 0.32rem;
                    justify-content: center;
                    position: unset;

                    div {
                        font-size: 0.22rem;
                    }

                    .img-box {
                        width: 0.07rem;
                    }
                }
            }
        }
    }
}
</style>